import { Injectable } from '@angular/core';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
        
    week(event: CalendarEvent, title: string){
        if(event.meta.colorclass =='orange-badge'){
       let data = '<div class="cal-sec ' +  event.meta.colorclass + '"> <img src="' + event.meta.path + '"   style="width:39px !important;">' 
                 + event.meta.vesselsName + " " +event.meta.eTA + '</div>';
       return data;
        }
    }

    // weekTooltip(event: CalendarEvent, title: string){       
    //     let tit = event.meta.portname + '<br />' + event.meta.vesselsName +'<br />' + event.meta.lable1 +': ' + event.meta.eTA + '<br />'+ event.meta.lable2 +': ' + event.meta.eTD +
    //     '<br />'+ 'Status: ' +event.meta.status ;                
    //    return  tit;
    // } 
        
    // dayTooltip(event: CalendarEvent, title: string){            
    //     let tit = event.meta.portname + '<br />' + event.meta.vesselsName +'<br />' + event.meta.lable1 +': ' + event.meta.eTA + '<br />'+ event.meta.lable2 +': ' + event.meta.eTD + 
    //     '<br />'+ 'Status: ' +event.meta.status ;                
    //    return  tit;
    // } 

    day(event: CalendarEvent, title: string){
        if(event.meta.colorclass =='orange-badge'){
        let tit = title;
        // if(event.allDay == false){
            
            tit ='<div class="cal-sec ' +  event.meta.colorclass + '">' 
            + event.meta.vesselsName + " " +event.meta.eTA + '</div>'; 
           
            //tit = event.meta.portname + '<br/>' + event.meta.vesselsName +'<br />' + 'ETA: ' + event.meta.eTA + '<br />'+ 'ETD: ' + event.meta.eTD;                
        // }                
        return tit;
    }
    }
}